export const roles: { label: string, value: string }[] = [
    {
        label: 'Executive',
        value: 'executive'
    },
    {
        label: 'Management',
        value: 'management'
    },
    {
        label: 'Employee',
        value: 'employee'
    },
    {
        label: 'Guest',
        value: 'guest'
    }
]
